module.exports = __webpack_public_path__ + "img/edge_hebergements_gite.675ded52.svg";